module.exports = __webpack_public_path__ + "media/country_flags/mo-c7cd71e8.png";